import { IMenuItem } from "src/libs/interfaces/layouts"
import { getRoute, getRouteByComponent } from "src/libs/layouts"
import { useEffect, useState } from "react"
import { useLocation } from "react-router"

const useFeedRoute = () => {
    const [isRoute, setRoute] = useState<boolean>(false)
    const location = useLocation() 
    useEffect(() => { 
        const landFeed: IMenuItem | null = getRouteByComponent("LandscapeView")
        setRoute(
            location.pathname.indexOf( 
                getRoute( landFeed || {} as IMenuItem)
            ) > -1  
        )
    }, [location])
    return isRoute
}
export default useFeedRoute